<!-- Events -->
<!-- itemCreated -->

<template>
  <v-container fluid>
    <v-row>
      <v-col
        sm="5"
        cols="12"
      >
        Platypus Number
      </v-col>
      <v-col
        sm="7"
        cols="12"
        class="list-lbl"
      >
        {{ selectedAccount.external_key}}
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col
        sm="5"
        cols="12"
      >
        Name
      </v-col>
      <v-col
        sm="7"
        cols="12"
      >
        {{ selectedAccount.display_text}}
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col
        sm="5"
        cols="12"
      >
        Status
      </v-col>
      <v-col
        sm="7"
        cols="12"
      >
        {{ selectedAccount.status}}
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col
        sm="5"
        cols="12"
      >
        Store
      </v-col>
      <v-col
        sm="7"
        cols="12"
      >
        <v-select
          v-model="selectedAccount._store.rowkey"
          :items="stores"
          item-text="display_text"
          item-value="rowkey"
          label="Store"
          outlined
          @change="onStoreChanged"
        ></v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // Utilities
  import moment from '@/assets/js/moment.min'
  import { mapActions, mapGetters } from 'vuex'
  import {
    ACCT_GET_ACCOUNT_INVOICES,
  } from '../../store/actions.types'
  import ApiService from '../../services/api.service'

  export default {
    name: 'ComponentAccountGeneral',

    inheritAttrs: false,

    props: {
      item: {
        type: Object,
        default: () => ({
          name: undefined,
          invoice: undefined,
          due_date: undefined,
          total: undefined,
          paid: undefined,
          is_paid: undefined,
          details: undefined,
        }),
      },
    },
    data: function () {
      return {
        currentObject: {},
        snapshotObject: {},
        formMode: '',
        formErrors: [],
        overlayAbsolute: true,
        overlayDisplay: false,
        headers: [
          {
            text: 'Invoice',
            align: 'start',
            sortable: false,
            value: 'invoice',
          },
          { text: 'Due', value: 'due_date' },
          { text: 'Amount', value: 'total' },
          { text: 'Status', value: 'status' },
        ],
        stores: [
          {
            rowkey: '00000000-0000-0000-0000-111111111111',
            display_text: 'Velociter',
          },
          {
            rowkey: '00000000-0000-0000-0000-222222222222',
            display_text: 'ezWave',
          },
        ],
      }
    },

    computed: {
      ...mapGetters({
        selectedAccount: 'acctSelectedAccount',
      }),
    },
    async created () {
      // this.init()
    },
    async mounted () {
      this.init()
    },
    methods: {
      ...mapActions({
        getInvoices: ACCT_GET_ACCOUNT_INVOICES,
      }),
      async init () {
        console.log(`Initializing ${name} setting values!`, this.item)
        this.formMode = 'read'
        // console.log(val)
        // this.currentObject = { ...this.item }
        // this.snapshotObject = { ...this.item }
      },
      async onStoreChanged () {
        try {
          const setStorePayload = {
            store_key: this.selectedAccount._store.rowkey,
          }
          const { data } = await ApiService.post(`account/${this.selectedAccount.rowkey}/assign-store`, setStorePayload)
          console.log(data)
        } catch (e) {
          console.log(e)
        }
      },
      resetForm () {
        this.overlayDisplay = false
        this.currentObject = { ...this.snapshotObject }
        this.formErrors = []
      },
      formatDate (value, format) {
        if (!format) {
          format = 'M/D/YYYY'
        }
        return moment(value).format(format)
      },
    },

  }
</script>

<style scoped>
  .list-lbl {
    font-weight: bold;
  }
</style>
